import { api, uploadFile } from './client';
import type { Visit, VisitTipo } from './types';
import type { Coords } from '../utils/geolocation';

export function fetchVisits() {
  return api<Visit[]>('/visits');
}

export function crearVisita(clientId: string, fechaProgramada: string, tipo?: VisitTipo) {
  return api<Visit>('/visits', {
    method: 'POST',
    body: JSON.stringify({ clientId, fechaProgramada, tipo: tipo || 'programada' }),
  });
}

export function tomarVisita(id: string) {
  return api(`/visits/${id}/tomar`, { method: 'PATCH' });
}

export function checkin(id: string, coords?: Coords | null) {
  return api(`/visits/${id}/checkin`, {
    method: 'PATCH',
    body: coords ? JSON.stringify(coords) : undefined,
  });
}

export function guardarTrabajo(id: string, descripcionTrabajo?: string, numeroTicket?: string) {
  const body: Record<string, string> = {};
  if (descripcionTrabajo !== undefined) body.descripcionTrabajo = descripcionTrabajo;
  if (numeroTicket !== undefined) body.numeroTicket = numeroTicket;
  return api(`/visits/${id}/trabajo`, { method: 'PATCH', body: JSON.stringify(body) });
}

export async function agregarFoto(id: string, dataUrl: string, tipo: 'antes' | 'despues') {
  const url = await uploadFile(dataUrl);
  return api(`/visits/${id}/fotos`, {
    method: 'POST',
    body: JSON.stringify({ url, tipo }),
  });
}

export async function guardarFirma(id: string, dataUrl: string, nombre: string) {
  const url = await uploadFile(dataUrl);
  return api(`/visits/${id}/firma`, {
    method: 'PATCH',
    body: JSON.stringify({ firmaUrl: url, firmaNombreCliente: nombre }),
  });
}

export function checkout(id: string, coords?: Coords | null) {
  return api(`/visits/${id}/checkout`, {
    method: 'PATCH',
    body: coords ? JSON.stringify(coords) : undefined,
  });
}

export function marcarFallida(id: string, motivoFallida: string) {
  return api(`/visits/${id}/fallida`, {
    method: 'PATCH',
    body: JSON.stringify({ motivoFallida }),
  });
}

export function posponerVisita(id: string, motivo: string, diasPosponer: number) {
  return api(`/visits/${id}/posponer`, {
    method: 'PATCH',
    body: JSON.stringify({ motivo, diasPosponer }),
  });
}

export function reasignarVisita(
  id: string,
  tecnicoId: string | null,
  fechaProgramada: string | null,
  motivo: string | null
) {
  const body: Record<string, unknown> = {};
  if (tecnicoId) body.tecnicoId = tecnicoId;
  if (fechaProgramada) body.fechaProgramada = fechaProgramada;
  if (motivo) body.motivo = motivo;
  return api(`/visits/${id}/reasignar`, { method: 'PATCH', body: JSON.stringify(body) });
}

export function cancelarVisita(id: string, motivo: string) {
  return api(`/visits/${id}/cancelar`, {
    method: 'PATCH',
    body: JSON.stringify({ motivo }),
  });
}
